<template>
    <form class="contact-popup-form" novalidate @submit.prevent="handleSubmit">
        <fieldset>
            <FormField
                v-for="field in visibleFields"
                :key="field.name"
                :field="field"
                :value="values[field.name]"
                :error="errors[field.name]"
                @update:value="updateValue(field.name, $event)"
            />

            <input
                v-for="field in honeypotFields"
                :key="field.name"
                type="text"
                :name="field.name"
                :value="values[field.name]"
                class="contact-popup__honeypot"
                tabindex="-1"
                autocomplete="off"
                aria-hidden="true"
                @input="updateValue(field.name, $event.target.value)"
            />
        </fieldset>

        <div class="Actions">
            <button
                type="submit"
                class="button button--full"
                :disabled="submitting"
            >
                {{ submitting ? "Verzenden..." : "Bericht versturen" }}
            </button>
        </div>
    </form>
</template>

<script>
import FormField from "./FormField.vue";

export default {
    name: "ContactForm",
    components: {
        FormField,
    },
    props: {
        fields: {
            type: Array,
            default: () => [],
        },
        errors: {
            type: Object,
            default: () => ({}),
        },
        submitting: {
            type: Boolean,
            default: false,
        },
    },
    emits: ["submit"],
    data() {
        return {
            values: this.createInitialValues(),
        };
    },
    computed: {
        visibleFields() {
            return this.fields.filter((field) => field.type !== "honeypot");
        },
        honeypotFields() {
            return this.fields.filter((field) => field.type === "honeypot");
        },
    },
    watch: {
        fields: {
            immediate: true,
            handler() {
                this.values = this.createInitialValues();
            },
        },
    },
    methods: {
        createInitialValues() {
            const values = {};

            this.fields.forEach((field) => {
                values[field.name] = "";
            });

            return values;
        },
        updateValue(name, value) {
            this.values = {
                ...this.values,
                [name]: value,
            };
        },
        handleSubmit() {
            this.$emit("submit", { ...this.values });
        },
    },
};
</script>
